import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projects, destination }) =>
    present(
      repository
        .moveProjects(projects, destination)
        .then(() => ({ projects, destination }))
        .catch((error) => Promise.reject({ error, projects, destination })),
    );
}

export type { Interactor };

export { createInteractor };
